// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SERi","productName":"Table_productName__2py1m"};